<div class="accordion-container">
  <h2>{{ data.accordion.title }}</h2>
  <p-accordion [multiple]="true" *ngFor="let item of data.accordion.content">
    <p-accordionTab [header]="item.header">
      <p *ngFor="let data of item.data" [innerHTML]="data"></p>
    </p-accordionTab>
  </p-accordion>
</div>
